<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
